import { Session } from '@/handler/session'
import router from '@/router'

export default {
  data() {
    return {
      sessionTimeout: 60 * 60 * 1000, // 30 minutos
      timerId: null,
      lastActivity: Date.now(),
    }
  },
  mounted() {
    this.startTimer()
    this.addEventListeners()
  },
  beforeUnmount() {
    this.stopTimer()
    this.removeEventListeners()
  },
  methods: {
    startTimer() {
      // 🛑 Evitar múltiples timers activos
      this.stopTimer()

      // ⏱️ Inicializa actividad al arrancar
      this.lastActivity = Date.now()

      const ignoredRoutes = ['Dashboard', 'Login', 'grafico_engorde']

      this.timerId = setInterval(() => {
        const currentRoute = this.$route?.name

        // ⛔ No chequear si estamos en rutas ignoradas
        if (ignoredRoutes.includes(currentRoute)) {
          return
        }

        // ⌛ Comparar inactividad
        if (Date.now() - this.lastActivity > this.sessionTimeout) {
          this.logoutAndRedirect()
        }
      }, 60 * 1000) // cada 60 segundos
    },
    stopTimer() {
      if (this.timerId) {
        clearInterval(this.timerId)
        this.timerId = null
      }
    },
    resetActivity() {
      this.lastActivity = Date.now()
    },
    addEventListeners() {
      const events = ['mousemove', 'keydown', 'wheel', 'mousedown', 'touchstart']
      events.forEach((event) => window.addEventListener(event, this.resetActivity))
    },
    removeEventListeners() {
      const events = ['mousemove', 'keydown', 'wheel', 'mousedown', 'touchstart']
      events.forEach((event) => window.removeEventListener(event, this.resetActivity))
    },
    logoutAndRedirect() {
      console.log('⏳ Usuario inactivo. Cerrando sesión.')
      Session.clear()
      router.push({ name: 'Login' })
    },
  },
}
